import $ from 'jquery';
import {wishlist} from "../queries";

$(document).ready(function () {
    $(document).on('click', '.ui-favorites', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Добавляем класс лоадера для элемента
        $(this).addClass('ui-favorites--loading');

        $(this).toggleClass('ui-favorites--active');
        let created = false;
        if ($('.header-favorite__count').length === 0) {
            created = true;
            $('.header-favorite').append(
                `<div class="header-favorite__count header-basket__count">1</div>`
            );
        }
        let favorID = $(this).attr('data-id');
        let doAction = '';
        if ($(this).hasClass('ui-favorites--active')) {
            doAction = 'delete';
        } else {
            doAction = 'add';
        }

        try {
            await addFavorite(favorID, doAction);
        } finally {
            // Убираем класс лоадера после завершения запроса
            $(this).removeClass('ui-favorites--loading');
        }

        if (!$(this).hasClass('ui-favorites--active')) {
            let count = $('.header-favorite__count').html();
            if (count !== 0) {
                $('.header-favorite__count').html(parseInt(count) - 1);
                if (document.location.pathname === '/wishlist/') {
                    $(this).parent().parent().parent().remove();
                }
                if (count == '1') {
                    $('.header-favorite__count').remove();
                }
                if (document.location.pathname === '/wishlist/' && count == '1') {
                    $('.page-catalog__items').html(`
                   <div class="page-catalog-empty">
                        <div class="page-catalog-empty__title">
                            Список избранного пуст.
                        </div>
                    </div>
                `);
                }
            }
        } else {
            let count = $('.header-favorite__count').html();
            if (!created) {
                $('.header-favorite__count').html(parseInt(count) + 1);
            }
        }
    });

    $(document).on('click', '.ui-favorites__text-button', async function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('ui-favorites__text-button--active');
        let created = false
        if ($('.header-favorite__count').length === 0) {
            created = true
            $('.header-favorite').append(
                `<div class="header-favorite__count header-basket__count">1</div>`
            )
        }
        let favorID = $(this).attr('data-id');
        let doAction = ''
        if ($(this).hasClass('ui-favorites__text-button--active')) {
            $(this).html('В избранном');
            doAction = 'delete';
        } else {
            $(this).html('В избранное');
            doAction = 'add';
        }
        addFavorite(favorID, doAction);

        if (!$(this).hasClass('ui-favorites__text-button--active')) {
            let count = $('.header-favorite__count').html()
            if (count !== 0) {
                $('.header-favorite__count').html(parseInt(count) - 1)
                if (document.location.pathname === '/wishlist/') {
                    $(this).parent().parent().parent().remove()
                }
                if (count == '1') {
                    $('.header-favorite__count').remove()
                }
                if (document.location.pathname === '/wishlist/' && count == '1') {
                    $('.page-catalog__items').html(`
                       <div class="page-catalog-empty">
                            <div class="page-catalog-empty__title">
                                Список избранного пуст.
                            </div>
                        </div>
                    `)
                }
            }
        } else {
            let count = $('.header-favorite__count').html()
            if (!created) {
                $('.header-favorite__count').html(parseInt(count) + 1)
            }
        }
    });
});

async function addFavorite(id, action) {
    const response = await wishlist(id, action);
    if (!response.isSuccess) {
        let result = response;
        if (result == 1) {
            $('.favor[data-item="' + id + '"]').addClass('active');
            let wishCount = parseInt($('#want .col').html()) + 1;
            $('#want .col').html(wishCount);
        }
        if (result == 2) {
            $('.favor[data-item="' + id + '"]').removeClass('active');
            let wishCount = parseInt($('#want .col').html()) - 1;
            $('#want .col').html(wishCount);
        }
    }

    let param = 'id=' + id + "&action=" + action;
}


